// extracted by mini-css-extract-plugin
module.exports = {"content_title_zh":"Dss_content_title_zh__pBzxB","content_title_en":"Dss_content_title_en__157Oh","starmap":"Dss_starmap__2_KSY"};